import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/whmcs': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 161V139.7L419.5 130.9 417.3 120.5 437.4 99.8 427 80.4 398 87.9 390.8 80.4 398.3 52.2 379.2 40.6 357.9 61.6 347.2 58.4 340.2 32H317.6L311.4 58.4 299.3 61.6 279.6 40.6 260.2 51.6 268.3 79.3 260.2 87.7 231.7 80.2 220.7 99.3 241.4 120.3 238.5 130.7 210 138.5 209.7 160.2 238.5 167.7 240.9 179.8 220.8 199.7 231.2 218.2 260.8 210.7 268 219.3 259.9 246.2 279.8 257.8 299.2 237.4 310.8 240.3 317.5 268.8 340.1 269.1 346.8 240.3 358.4 236.8 379.1 258.4 399.5 246.3 390.7 218.3 398.5 210.2 427.3 219 437.6 198.9 416.7 180.1 418.9 168 448 161zM328.8 206.2C297.5 206.2 272 180.8 272 149.4S297.4 92.6 328.8 92.6 385.6 118 385.6 149.4C385.6 180.9 360.2 206.2 328.8 206.2zM401.1 222.6L448 237.1V277L392.9 290.4 388.8 313.1 427.7 348.4 408.5 386.3 354.5 369.6 339.9 384.8 356.6 437.3 318.3 460 279.4 419.5 257.7 426.1 245.1 480.1 202.7 479.6 190.1 426 168.4 420.4 132 458.8 94.6 437.1 109.8 386.6 96.1 370.5 40.6 384.6 20.9 349.8 58.8 312.4 54 289.6 0 275.5 0.5 234.6 54 219.9 59.7 200.2 20.8 160.8 41.5 125 95.1 139.1 110.3 123.4 95.1 71.4 131.5 50.7 168.3 90.1 191 84 202.6 32H245L256.6 77.9 234 72 227.7 70.3 224.4 76 213.4 95.1 210.1 100.7 214.7 105.3 231.9 122.7 231.6 123.7 207.8 130.2 201.6 131.9 201.5 138.3 201.3 151.2C153.8 161.6 118 204 118 254.7 118 313 165.3 360.4 223.7 360.4 274.2 360.4 316.4 325 326.9 277.6L340.1 277.8 347 277.9 348.6 271.2 354.2 247.2 356.1 246.6 373.2 264.4 377.9 269.3 383.7 265.9 404.1 253.8 409.9 250.3 407.9 243.8 401.1 222.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/whmcs.js
// module id = QQC1
// module chunks = 144